
{
  "fr": {
    "configuratorEditor": {
      "tabs": {
        "product": "Produit",
        "content": "Personnalisation"
      },
      "changeThemeAlert": "Vous vous apprêtez à modifier le style de votre gobelet. Vous perdrez toute la configuration en cours de personnalisation.",
      "themePickerButton": "Changer de visuel"
    }
  }
}
